import { Link as RouterLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateUser, listUser } from "../../../redux/actions/userActions";

import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/EditOutlined";

const User = (props) => {
    const { id, name, email, role, isActive } = props.user;
    const from = props.from;
    const orgId = props.organizationId;

    const dispatch = useDispatch();

    const changeStatus = (userId, status) => {
        const label = status ? `Activate ${name}?` : `Deactivate ${name}?`;
        if (!window.confirm(label)) return;
        const obj = { id: userId, isActive: status };
        dispatch(updateUser({ reqData: obj, orgId })).then(() => {
            dispatch(listUser(1, 20, "role", "", "", "", from, orgId));
        });
    };

    const fromOrgReadonly = from === "organization";

    return (
        <TableRow hover>
            <TableCell sx={{ fontWeight: 600 }}>{name}</TableCell>
            <TableCell sx={{ color: "text.secondary" }}>{email}</TableCell>
            <TableCell>
                <Chip label={role} size="small" variant="outlined" />
            </TableCell>
            <TableCell>
                {fromOrgReadonly ? (
                    <Chip
                        label={isActive ? "Active" : "Inactive"}
                        size="small"
                        color={isActive ? "success" : "default"}
                        variant={isActive ? "filled" : "outlined"}
                    />
                ) : (
                    <Chip
                        label={isActive ? "Active" : "Inactive"}
                        size="small"
                        color={isActive ? "success" : "default"}
                        variant={isActive ? "filled" : "outlined"}
                        onClick={() => changeStatus(id, !isActive)}
                        sx={{ cursor: "pointer" }}
                    />
                )}
            </TableCell>
            {!fromOrgReadonly && (
                <TableCell align="center">
                    <IconButton component={RouterLink} to={`/user/edit/${id}`} title="Edit user" size="small">
                        <EditIcon fontSize="small" />
                    </IconButton>
                </TableCell>
            )}
        </TableRow>
    );
};

export default User;
